import { render } from "./FilterSegmentsSelected.vue?vue&type=template&id=b95bc40e&ts=true"
import script from "./FilterSegmentsSelected.vue?vue&type=script&lang=ts"
export * from "./FilterSegmentsSelected.vue?vue&type=script&lang=ts"

import "./FilterSegmentsSelected.vue?vue&type=style&index=0&id=b95bc40e&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__